import {AfterViewChecked, AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {MatDialog} from '@node_modules/@angular/material';
import {User} from '@models/user';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {OwnerSubscription} from '@models/ownerSubscription';
import {SubscriptionScenario} from '@models/subscriptionScenario';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {SignOut} from '@store/auth/actions';
import {RemoveAllPrograms} from '@store/program/actions';
import {AuthFacade} from '@facades/auth/authFacade';
import * as ProgramReducer from '@store/program/reducers';

@Component({
  selector: 'app-manage-admin-subscription-dialog',
  templateUrl: './manage-admin-subscription-dialog.component.html',
  styleUrls: ['./manage-admin-subscription-dialog.component.scss']
})
export class ManageAdminSubscriptionDialog implements OnInit, AfterViewInit {
  static modalRef;
  subscribes = [];
  user: User;
  subscription: OwnerSubscription;
  scenario: SubscriptionScenario;
  confirmDialog;

  constructor(
    private subscriptionService: SubscriptionService,
    private authStore: Store<AuthReducer.AuthState>,
    public dialog: MatDialog,
    private authFacade: AuthFacade,
    private programStore: Store<ProgramReducer.ProgramState>
  ) {
    //
  }

  ngOnInit() {
    this.getUser();
    this.fetchSubscription();
  }

  ngAfterViewInit() {
    //
  }

  getUser() {
    this.subscribes.push(this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    ));
  }

  fetchSubscription() {
    this.subscriptionService
      .getAuthedOwnerSubscription()
      .subscribe(
        (resp: { data: OwnerSubscription }) => {
          this.subscription = resp.data;

          if (this.subscription.scenario) {
            this.scenario = this.subscription.scenario;
          }
          console.log(this.subscription);
          console.log(this.scenario);
      });
  }

  handleCancelSubscriptionButton() {
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.methodDelete = 'cancelAdminSubscription';
    ConfirmModalComponent.textModal = 'Once your subscription is cancelled, you and your customers will loose access to My Kool Cat and all information will be deleted. \n Are you Sure you want to cancel your subscription?';
    ConfirmModalComponent.textButton = 'Yes';
    ConfirmModalComponent.cancelButtonText = 'No';
    ConfirmModalComponent.methodDeleteParam = 'member';
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
  }

  handleClose() {
    if (ManageAdminSubscriptionDialog.modalRef) {
      ManageAdminSubscriptionDialog.modalRef.close();
    }
  }

  cancelAdminSubscription() {
    console.log('i cancelAdminSubscription', this);
    this.subscriptionService
      .cancelAuthedOwnerSubscription()
      .subscribe(
        (resp: { data: OwnerSubscription }) => {
          const ownerSubscription = resp.data;
          if (ownerSubscription.status === 'cancelled') {
            this.handleClose();
            if (ConfirmModalComponent.modalRef) {
              ConfirmModalComponent.modalRef.close();
            }
            this.openAdminSubscriptionCancelledDialog();

            setTimeout(() => {
              this.authStore.dispatch(new SignOut(this.authFacade));
              this.programStore.dispatch(new RemoveAllPrograms());
            }, 100);
          }
        }
      );
  }

  openAdminSubscriptionCancelledDialog(): void {
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.textModal = 'Your subscription has been cancelled';
    ConfirmModalComponent.withButtons = false;
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
  }
}
